import React from 'react';
import Pagination from '../../pagination';
import BookstoreProduct from '../bookstore-product';
import useCart from '../../../hooks/use-cart';
import Loading from '../../loading';

interface Props {
  products: any;
  pageIndex: any;
  setPageIndex: any;
  showPagination?: boolean;
  itemFormat?: string;
}

const BookstoreProductGrid: React.FC<Props> = ({
  products,
  pageIndex,
  setPageIndex,
  showPagination = true,
  itemFormat,
}) => {
  const { data, error, loading } = useCart();

  if (loading) {
    return <Loading />;
  }
  if (!data || error) return null;

  const cart = data.cart;

  return (
    <React.Fragment>
      <div className="product-grid">
        {products.content.map((product) => (
          <BookstoreProduct
            key={product.id}
            cart={cart}
            product={product}
            itemFormat={itemFormat}
          />
        ))}
      </div>
      {showPagination && (
        <Pagination
          onPageChange={(page) => setPageIndex(page)}
          totalCount={products.totalElements}
          siblingCount={1}
          currentPage={pageIndex}
          pageSize={12}
        />
      )}
      {/* language=CSS */}
      <style jsx>{`
        .product-grid {
          margin-top: 2rem;
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
        }
      `}</style>
    </React.Fragment>
  );
};

export default BookstoreProductGrid;
